import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <Card> and its sub-parts.
export function Card({ className = "", children, ...props }) {
  return (
    <div
      className={cn("bg-white rounded border border-gray-200 shadow-xs", className)}
      {...props}
    >
      {children}
    </div>
  )
}

export function CardImg({ className = "", ...props }) {
  // Mirrors the old .card-img-top rule (contained, fixed height).
  return (
    <img
      className={cn("w-full h-40 object-contain object-center", className)}
      {...props}
    />
  )
}

export function CardBody({ className = "", children, ...props }) {
  return (
    <div className={cn("p-4", className)} {...props}>
      {children}
    </div>
  )
}

export function CardTitle({ className = "", children, ...props }) {
  return (
    <h5 className={cn("text-base font-bold", className)} {...props}>
      {children}
    </h5>
  )
}

export function CardText({ className = "", children, ...props }) {
  return (
    <p className={cn("text-sm text-gray-700", className)} {...props}>
      {children}
    </p>
  )
}

Card.Img = CardImg
Card.Body = CardBody
Card.Title = CardTitle
Card.Text = CardText

export default Card
